export const VERDICT_VISUAL = {
    fire: { tag: 'FIRE YOUR AGENCY', color: 'error' },
    borderline: { tag: 'WORTH SWITCHING', color: 'warning' },
    keep: { tag: "YOU'RE ALREADY LEAN", color: 'success' },
};
export const VERDICT_HEADLINE = {
    fire: 'Your Agency Is Costing You Far More Than Hiring Direct.',
    borderline: "You're Overpaying Your Agency — and Switching Pays for Itself.",
    keep: "Good News — You're Already Running Lean.",
};
/** Dynamic subheadline; tokens are replaced at render. Copy stays comparison-true per verdict. */
export const VERDICT_SUBHEAD = {
    fire: 'Based on your numbers, your agency markup runs about {markupQtr} a quarter — {annual} a year. Stanor replaces that same workflow for {stanorYear} a year, putting {savings} a year back in your business.',
    borderline: 'You\'re paying roughly {annual} a year in agency markup. Stanor\'s flat {stanorYear} a year would save you {savings} a year — starting month one.',
    keep: 'At your current volume your agency markup is about {annual} a year — less than Stanor\'s flat {stanorYear} a year. On price alone, you\'re not overpaying today. The math tips in Stanor\'s favour the moment you hire more.',
};
export const VERDICT_CTA = {
    fire: {
        heading: "You Don't Need an Agency. You Need a System.",
        primary: 'Start Free — No Card Required →',
        secondary: 'Book a 15-min demo',
        socialProof: 'Hire direct and cut your staffing-agency markup with Stanor.',
    },
    borderline: {
        heading: 'Cut the Markup. Keep the Hires.',
        primary: 'Start Free — No Card Required →',
        socialProof: 'Hire direct and cut your staffing-agency markup with Stanor.',
    },
    keep: {
        heading: 'Scaling Up? Stanor Grows With You.',
        primary: 'Try Stanor Free →',
        socialProof: 'Direct hiring, AI screening, and anti-ghosting — all on one flat plan.',
    },
};
